import { useCachedSelectedProject, useTranslation } from 'hooks';
import { TrialBanner } from 'shared/ui/trial-banner/trial-banner';
import cls from './improvement-trial-banner.module.scss';

export const ImprovementTrialBanner: React.FC = () => {
  const { t } = useTranslation();
  const { isTrial, isTrialExpired, testingB } = useCachedSelectedProject();

  if (!isTrial || !testingB) {
    return null;
  }

  return (
    <div className={cls.trialBannerWrapper}>
      <TrialBanner
        variant='prominent'
        title={t(isTrialExpired ? 'trialExpiredBanner' : 'trialRulesBanner')}
        description={t(
          isTrialExpired
            ? 'trialExpiredBannerDescription'
            : 'trialImprovementCenterDescription'
        )}
      />
    </div>
  );
};
